
import '../css/About.css'
import { useBuildInfo } from '../hooks/useBuildInfo';



function About () {
    const { version, buildDate } = useBuildInfo();
    return (
        <div>
            <h4>About This Version</h4>
            <strong>Version: {version} Built On: {new Date(buildDate).toLocaleString('en-GB')}</strong>
            <br/>
            <ul>
                <li>1.1.7 Docusign Contract Sending Live</li>
                <li>1.1.6 Added Support for HMRC Agent Form 64-8</li>
                <li>1.1.5 Fix to Contract Agreement Date</li>
                <li>1.1.4 Contract Agreement Creaation</li>
                <li>1.1.3 Customer Emails Pulled in from Email</li>
                <li>1.1.2 Realteime Lead Updated.</li>
                <li>1.1.1 Basic Email Send Functionality Working.</li>
                <li>1.1.1 Added Company House Info and displays Filing Documents / Allows them to be opened, downloaded and printed</li>
                <li>1.0.A Filters Working for Filing History</li>
                <li>1.0.A People/Officerd added for Company House.</li>
                <li>1.0.9 Added New Status Codes</li>
                <li>1.0.9 Date Created / Status and Company Default to larger sized Columns when opened</li>
            </ul>
        </div>
    )
}

export default About;